import classNames from 'classnames';

type Status = 'active' | 'expiring' | 'expired';

const STATUS_DOT_CLASSES: Record<Status, string> = {
    active: 'bg-success-mid',
    expiring: 'bg-warning',
    expired: 'bg-error'
};

const STATUS_HALO_CLASSES: Record<'expiring' | 'expired', string> = {
    expiring: 'bg-warning/70',
    expired: 'bg-error/40'
};

export const BankIconWithDot = ({
    status,
    className
}: {
    status: Status;
    className?: string;
}) => {
    const hasHalo = ['expiring', 'expired'].includes(status);

    return (
        <span
            className={classNames(
                'relative inline-flex aspect-square h-auto w-full',
                className
            )}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
            >
                <path
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.667 18.333c0-.46.373-.833.833-.833h15a.833.833 0 0 1 0 1.667h-15a.833.833 0 0 1-.833-.834M5 8.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.666 0V9.167c0-.46.373-.834.833-.834M8.333 8.333c.46 0 .834.373.834.834V15A.833.833 0 1 1 7.5 15V9.167c0-.46.373-.834.833-.834M11.667 8.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.667 0V9.167c0-.46.373-.834.834-.834M15 8.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.666 0V9.167c0-.46.373-.834.833-.834M9.558.96a.83.83 0 0 1 .884 0l6.666 4.167a.834.834 0 0 1-.441 1.54H3.333a.833.833 0 0 1-.441-1.54zM6.24 5h7.522L10 2.65z"
                />
            </svg>
            <span
                aria-hidden="true"
                className="absolute right-[-6%] top-[-8%] flex size-[41.67%] items-center justify-center"
            >
                {hasHalo && (
                    <span
                        className={classNames(
                            'absolute size-full animate-beacon rounded-full',
                            STATUS_HALO_CLASSES[
                                status as 'expired' | 'expiring'
                            ]
                        )}
                    />
                )}
                <span
                    className={classNames(
                        'size-full rounded-full',
                        STATUS_DOT_CLASSES[status]
                    )}
                />
            </span>
        </span>
    );
};
